<template>
    <section class="overflow-hidden">
        <div class="row">
            <div class=" col-lg-3 pt-5 pl-5 col-md-6 footer-bordor footer-lists">
                <p class="f-16 text-primary fw-600 ">Company</p>
                <p class="f-16 mb-2 position-overlays" v-for="(item,index) in compnayList" :key="index">
                    <a class="text-black text-decoration-none" :href="item.link">
                    {{item.title}}
                    </a>
                </p>
            </div>
             <div class="col-lg-3 pt-5 pl-5 col-md-6 footer-bordor footer-lists">
                <p class="f-16 text-primary fw-600">Features</p>
                <p class="f-16 mb-2 position-overlays" v-for="(item,index) in features" :key="index">
                    <a class="text-black text-decoration-none" :href="item.link">
                    {{item.title}}
                    </a>
                </p>
            </div>
            <div class="col-lg-3 pt-5 pl-5 col-md-6 footer-bordor footer-lists">
                <p class="f-16 text-primary fw-600">Industries we Support</p>
                <p class="f-16 mb-2 position-overlays" v-for="(item,index) in industries" :key="index">
                    <a class="text-black text-decoration-none" :href="item.link">
                    {{item.title}}
                    </a>
                </p>
            </div>
            <div class="col-lg-3 col-md-6 px-0 d-none d-md-block">
                <div class="social d-flex align-items-center justify-content-center">
                <p class="f-20 d-flex align-items-end gap-5"><facebook-icon></facebook-icon>Facebook</p>
                </div>
                <div class="social d-flex align-items-center justify-content-center">
                <p class="f-20 d-flex align-items-end gap-5"><twiter-icon></twiter-icon> Twitter</p>
                </div>
                <div class="social d-flex align-items-center justify-content-center">
                <p class="f-20 d-flex align-items-end gap-5"><instagram-icon></instagram-icon> LinkedIn</p>
                </div>
                <div class="social d-flex align-items-center justify-content-center">
                <p class="f-20 d-flex align-items-end gap-5"><linked-in-icon></linked-in-icon>Instagram</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 px-0 footer-log d-block d-md-none">
                <div class="social d-flex align-items-center justify-content-center">
                <p class="f-20 d-flex align-items-end gap-5"><facebook-icon></facebook-icon></p>
                </div>
                <div class="social d-flex align-items-center justify-content-center">
                <p class="f-20 d-flex align-items-end gap-5"><twiter-icon></twiter-icon> </p>
                </div>
                <div class="social d-flex align-items-center justify-content-center">
                <p class="f-20 d-flex align-items-end gap-5"><instagram-icon></instagram-icon></p>
                </div>
                <div class="social d-flex align-items-center justify-content-center">
                <p class="f-20 d-flex align-items-end gap-5"><linked-in-icon></linked-in-icon></p>
                </div>
            </div>
        </div>
        <!-- <div class="row ">
            <div class="col-12 trusted-companies-footer">
                <div style="height:70px;" class="footer-bordor p-3 d-flex justify-content-center align-items-center" v-for="CompImages in companies" :key="CompImages.id">
                    <img class="img-fluid" :src="CompImages.image" alt="">
                </div>
            </div>
         </div> -->
        <div class="row justify-content-center btn-bg-golden p-3">
            <p class="f-18 fw-600 mb-0">All Rights Reserved © 2024</p>
        </div>
    </section>
</template>

<script>
import FacebookIcon from '../components/Icons/FacebookIcon.vue'
import InstagramIcon from '../components/Icons/InstagramIcon.vue'
import LinkedInIcon from '../components/Icons/LinkedInIcon.vue'
import TwiterIcon from '../components/Icons/TwiterIcon.vue'


export default {
  components: { FacebookIcon ,TwiterIcon, InstagramIcon, LinkedInIcon },
     data(){
        return{
            companies:[{id: '1' , image: '/images/i.png'},{id: '2' , image: '/images/c.png'} , {id: '3' , image: '/images/v.png'},{id: '4' , image: '/images/l.png'},{id: '5' , image: '/images/b.png'}],
            compnayList:[{
                link:"/demo",
                title:"Request a Demo"
            },{
                link:"/coming_soon",
                title:"Pricing"
            },{
                link:"/about_us",
                title:"About"
            },{
                link:"/terms-and-conditions",
                title:"Terms & Conditions"
            },{
                link:"/privacy-policy",
                title:"Privacy Policy"
            },{
                link:"/coming_soon",
                title:"How it Works"
            },
            {
                link:"/coming_soon",
                title:"Services"
            },
            ],
            features:[{
                link: "/features/point-of-sale",
                title: "Repair Shop POS",
            },{
                link: "/features/inventory",
                title: "Inventory Management",
            },{
                link: "/features/repair-ticket",
                title: "Repair Ticket Management",
            },{
                link: "/features/marketing",
                title: "Marketing",
            },{
                link: "/features/payments",
                title: "Payments",
            },{
                link: "/features/online-appointments",
                title: "Client Appointment Scheduling",
            },{
                link: "/features/store-credits",
                title: "Store Credits",
            },{
                link: "/features/employee-management",
                title: "Employee Management",
            },{
                link: "/features/reporting",
                title: "Reporting",
            },{
                link: "/features/billing-invoice",
                title: "Billing & Invoice",
            },{
                link: "/features/self-check-in",
                title: "Self Check-In",
            },
            ],
            industries:[{
                link: "coming_soon",
                title: "Cell Phone Repair"
            },{
                link: "coming_soon",
                title: "Computer Repair"
            },{
                link: "coming_soon",
                title: "Repair Depots"
            },{
                link: "coming_soon",
                title: "MSP’s"
            },{
                link: "coming_soon",
                title: "Jewelry Repair"
            },{
                link: "coming_soon",
                title: "Watch Repair"
            },{
                link: "coming_soon",
                title: "Electronics Repair"
            },{
                link: "coming_soon",
                title: "Mail-in Service Providers"
            },{
                link: "coming_soon",
                title: "Field Service Technicians"
            },{
                link: "coming_soon",
                title: "Device Management Companies"
            }]
        }
    }
}
</script>

<style>

</style>